import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { Patient } from '~/domain/patient/patient';
import {
    patientRepositoryState,
    selectedPatientIdState,
} from '~/state/atoms/patientAtoms';

export default function useSelectedPatient(): Patient | undefined {
    const patientRepository = useRecoilValue(patientRepositoryState);
    const selectedPatientId = useRecoilValue(selectedPatientIdState);

    return useMemo(() => {
        const allPatients: Patient[] = patientRepository.getAll();
        return allPatients?.find(
            (p) => p.dataSet.PatientID === selectedPatientId
        );
    }, [patientRepository, selectedPatientId]);
}
